<template>
  <div class="ordini" v-loading="loading">

    <transition name="fade">
      <ricerca v-show="showSearchPanel" :prefixApp="prefixApp"
                        @closeRicerca="closeSearch"
                        @cerca="cerca"
                        @loadingOff="setLoading(false)"></ricerca>
    </transition>

    <div class="header-tab col-24 no-padding row row-custom">
      <div class="col-2 no-padding icon-search">
        <el-tooltip class="item" effect="dark" :content="$t('ordini.cerca')" placement="top-start">
          <el-button @click="openSearch">
            <icon name="riv-filter" scale="1.4"></icon>
          </el-button>
        </el-tooltip>
      </div>
    </div>

    <el-table :data="listOrdini" :row-class-name="tableRowClassName" @sort-change="sortChange" :row-key="getTableKey" class="custom-table">
      <el-table-column
        header-align="center" align="center"
        width="80">

        <template slot-scope="scope">
          <div class="name-wrapper row-custom row">
            <div class="col-12 no-padding">
              <el-tooltip :content="($t('ordini.ordineChiuso'))" placement="left">
                <icon name="riv-denied" scale="0.9" v-if="(scope.row.staOrd === 'C')">></icon>
              </el-tooltip>
            </div>
            <div class="col-12 no-padding">
              <el-tooltip :content="($t('ordini.ordineConScaduto'))" placement="right">
                <icon style="color: #d7cb0c" name="riv-bell" scale="1" v-if="(scope.row.seParzScaduto === 'S')"></icon>
              </el-tooltip>
            </div>
          </div>
        </template>

      </el-table-column>
      <el-table-column
        header-align="center" align="center" prop="numOrd"
        :label="$t('ordini.ordine')" sortable="custom" class-name="sfondino2"
        width="100">

        <template slot-scope="scope">
          <div class="name-wrapper pointer"
                      @click="selectOrdine(scope.row, scope.row.fornitori[0].tipoAzione.indexOf('2') >= 0)"
                      v-if="(scope.row.fornitori[0].tipoAzione.indexOf('1') >= 0)"
          >
            {{ scope.row.numOrd }}
          </div>
          <div class="name-wrapper" v-else>
            {{ scope.row.numOrd }}
          </div>
        </template>

      </el-table-column>
      <el-table-column
        header-align="center" align="center" prop="datOrd"
        :label="$t('ordini.dataOrdine')" sortable="custom"
        width="160">

        <template slot-scope="scope">
          <div class="name-wrapper">
            {{ moment(scope.row.datOrd, 'DDMMYYYY').format('DD/MM/YYYY') }}
          </div>
        </template>

      </el-table-column>
      <el-table-column
        prop="desMag"
        :label="$t('ordini.stabilimento')"
        min-width="120">
      </el-table-column>

      <el-table-column type="expand" width="50">
        <template slot-scope="props">

          <el-table :data="getArray(props.$index)" :cell-class-name="cellClassAccordion" :show-header="false" class="custom-table">
            <el-table-column
              width="80">

              <template>
                <div class="name-wrapper">
                  {{ ' ' }}
                </div>
              </template>

            </el-table-column>
            <el-table-column
              width="85">

              <template>
                <div class="name-wrapper">
                  {{ ' ' }}
                </div>
              </template>

            </el-table-column>
            <el-table-column
              width="160">

              <template>
                <div class="name-wrapper">
                  {{ ' ' }}
                </div>
              </template>

            </el-table-column>
            <el-table-column
              min-width="120">

              <template>
                <div class="name-wrapper">
                  {{ ' ' }}
                </div>
              </template>

            </el-table-column>
            <el-table-column
              width="50">

              <template>
                <div class="name-wrapper">
                  {{ ' ' }}
                </div>
              </template>

            </el-table-column>
            <el-table-column
            min-width="220">

              <template slot-scope="scope">
                <div class="name-wrapper fornitore">
                  {{ scope.row.descFor }}
                </div>
              </template>

            </el-table-column>
            <el-table-column header-align="center" align="center" width="70" v-if="ifAbilitatoAssociaDip">

              <template slot-scope="scope">
                <div class="action">
                  <div class="row row-custom">
                    <el-badge
                      :value="scope.row.numDipendenti"
                      class="item"
                      :hidden="(scope.row.numDipendenti <= 0)"
                    >
                    <el-button class="associa-button"
                      v-if="(scope.row.tipoAzione.indexOf('3') >= 0)"
                      @click.native="associaDip(props.row, scope.row,'E')">
                      <icon name="riv-users" scale="1" class="ord-open"></icon>
                      <!--{{($t('ordini.associa'))}}-->
                    </el-button>
                    <el-button class="mostra-button"
                      v-if="(scope.row.tipoAzione.indexOf('3') < 0) && scope.row.numDipendenti > 0"
                      @click.native="associaDip(props.row, scope.row,'S')">
                      <icon name="riv-users" scale="1" class="ord-open"></icon>
                      <!--{{($t('ordini.mostra'))}}-->
                    </el-button>
                  </el-badge>
                    <!--<div class="col-12 right no-padding">
                      <el-popover
                        placement="right"
                        width="400"
                        trigger="click">
                        <div>
                          <div v-for="dip in scope.row.dipendenti" :key="dip.codDip" class="ordini-elencoDip">
                            <span>{{dip.codDip}} - {{dip.descDip}}</span>
                          </div>
                        </div>
                        <span slot="reference">
                          <el-badge
                            :value="scope.row.numDipendenti"
                            class="item"
                            :hidden="(scope.row.numDipendenti <= 0)"
                          ></el-badge>
                            </span>
                      </el-popover>
                    </div>
                    <div class="col-12 no-padding">
                      <icon name="riv-users" scale="1" class="ord-open"
                            v-if="(scope.row.tipoAzione.indexOf('3') >= 0)"
                            @click.native="associaDip(scope.row, scope.row)">
                      </icon>
                      <icon name="riv-users" scale="1" class="ord-close"
                              v-if="(scope.row.tipoAzione.indexOf('3') < 0) && scope.row.numDipendenti > 0"
                      ></icon>
                    </div>-->
                  </div>
                </div>
              </template>
            </el-table-column>

            <el-table-column header-align="center" align="center" width="40" v-if="ifAbilitatoDocRichiesti">
              <template slot-scope="scope">
                <div class="action">
                  <icon class="ord-doc" :name="(scope.row.staSitDoc === '0' ? 'riv-docAccepted_2' : 'riv-docRefused_2')" scale="1"
                          v-if="(scope.row.tipoAzione.indexOf('4') >= 0)"
                          @click.native="goToDocumenti(props.row, scope.row)"></icon>
                </div>
              </template>
            </el-table-column>

            <el-table-column header-align="center" align="center" width="40">

              <template slot-scope="scope">
                <div class="action">
                  <icon name="riv-arrow" scale="1" v-if="(scope.row.tipoAzione.indexOf('1') >= 0)" :class="[props.$index]"
                        @click.native="selectOrdine(props.row, scope.row.tipoAzione.indexOf('2') >= 0)"></icon>
                </div>
              </template>
            </el-table-column>

            <!--<el-table-column
              width="150">

              <template slot-scope="scope">
                <div class="actions">
                  <div class="row row-custom">
                    <div class="col-8 pointer">
                      <icon name="riv-fornitori" scale="1" v-if="false"></icon>
                      <div v-else>&nbsp;</div>
                    </div>
                    <div class="col-8 pointer">
                      <icon :name="(scope.row.staSitDoc === '0' ? 'riv-docAccepted_2' : 'riv-docRefused_2')" scale="1"
                            v-if="(scope.row.tipoAzione.indexOf('4') >= 0)"
                            @click.native="goToDocumenti(props.row, scope.row)"></icon>
                      <div v-else>&nbsp;</div>
                    </div>
                    <div class="col-8 pointer">
                      <icon name="riv-arrow" scale="1" v-if="(scope.row.tipoAzione.indexOf('1') >= 0)" :class="[props.$index]"
                            @click.native="selectOrdine(props.row, scope.row.tipoAzione.indexOf('2') >= 0)"></icon>
                      <div v-else>&nbsp;</div>
                    </div>
                  </div>
                </div>
              </template>

            </el-table-column>-->
          </el-table>

        </template>
      </el-table-column>
      <el-table-column
        :label="$t('ordini.fornitore')"
        min-width="220">

        <template slot-scope="scope">
          <div class="name-wrapper">
            {{ scope.row.fornitori[0].descFor }}
          </div>
        </template>

      </el-table-column>
      <el-table-column
        width="40">

        <template slot-scope="scope">
          <div class="name-wrapper" v-if="(scope.row.hasOwnProperty('keyDoc') && scope.row.keyDoc !== '')">
            <div v-if="scope.row.statusDoc === 'N'" />
            <div v-else @click="goToUpload(scope.row)" class="pointer">
              <el-tooltip class="item" effect="dark"
                          :content="$t('ordini.upload')"
                          placement="left"
              >
                <icon name="riv-docUpload_2_green" scale="1.3" v-if="(scope.row.statusPVOrdFor === '1')" />
                <icon name="riv-docUpload_2_red" scale="1.3" v-else />
              </el-tooltip>
            </div>
          </div>
        </template>

      </el-table-column>
      <el-table-column
        width="40">

        <template slot-scope="scope">
          <div class="name-wrapper" v-if="(scope.row.hasOwnProperty('keyDoc') && scope.row.keyDoc !== '')">
            <div v-if="scope.row.statusDoc === 'N'">
              <icon name="riv-pdf_RGB" scale="1.4" @click.native.stop="setStatusDoc(scope.row)" class="pointer" />
            </div>
            <div v-else>
              <el-tooltip class="item" effect="dark"
                          :content="((scope.row.username) + ' - ' + moment(scope.row.dataPV, 'DDMMYYYY').format('DD/MM/YYYY') + ' ' + moment(scope.row.oraPV, 'HHmm').format('HH:mm'))"
                          placement="left"
              >
                <icon name="riv-pdf_BW" scale="1.4" @click.native.stop="setStatusDoc(scope.row)" class="pointer" />
              </el-tooltip>
            </div>
          </div>
        </template>

      </el-table-column>
      <el-table-column
        width="65" class-name="col-variante">

        <template slot-scope="scope">
          <div class="name-wrapper" v-if="(scope.row.hasOwnProperty('variante') && scope.row.variante !== '000')">
            <div class="variante">
              {{ 'v.' + parseInt(scope.row.variante) }}
            </div>
          </div>
        </template>

      </el-table-column>
      <el-table-column header-align="center" align="center" width="70" v-if="ifAbilitatoAssociaDip">

        <template slot-scope="scope">
          <div class="action">
            <div class="row row-custom">
              <el-badge
                :value="scope.row.fornitori[0].numDipendenti"
                class="item"
                :hidden="(scope.row.fornitori[0].numDipendenti <= 0)"
              >
                <el-button class="associa-button"
                  v-if="(scope.row.fornitori[0].tipoAzione.indexOf('3') >= 0)"
                  @click.native="associaDip(scope.row, scope.row.fornitori[0],'E')"
                >
                  <icon name="riv-users" scale="1" class="ord-open" />
                </el-button>
                <el-button class="mostra-button"
                  v-if="(scope.row.fornitori[0].tipoAzione.indexOf('3') < 0) && scope.row.fornitori[0].numDipendenti > 0"
                  @click.native="associaDip(scope.row, scope.row.fornitori[0],'S')"
                >
                  <icon name="riv-users" scale="1" class="ord-open" />
                </el-button>
              </el-badge>
              <!--<icon name="riv-users" scale="1" class="ord-open"
                          v-if="(scope.row.fornitori[0].tipoAzione.indexOf('3') >= 0)"
                          @click.native="associaDip(scope.row, scope.row.fornitori[0])"></icon>
                <icon name="riv-users" scale="1" class="ord-close"
                          v-if="(scope.row.fornitori[0].tipoAzione.indexOf('3') < 0) && scope.row.fornitori[0].numDipendenti > 0"
                        ></icon>-->


              <!--<div class="col-12 right no-padding">
                <el-popover
                  placement="right"
                  width="400"
                  trigger="click">
                  <div>
                    <div v-for="dip in scope.row.fornitori[0].dipendenti" :key="dip.codDip" class="ordini-elencoDip">
                      <span>{{dip.codDip}} - {{dip.descDip}}</span>
                    </div>
                  </div>
                  <span slot="reference">
                        <el-badge
                      :value="scope.row.fornitori[0].numDipendenti"
                      class="item"
                      :hidden="(scope.row.fornitori[0].numDipendenti <= 0)"
                    ></el-badge>
                      </span>
                </el-popover>
              </div>
              <div class="col-12 no-padding">
                <icon name="riv-users" scale="1" class="ord-open"
                          v-if="(scope.row.fornitori[0].tipoAzione.indexOf('3') >= 0)"
                          @click.native="associaDip(scope.row, scope.row.fornitori[0])"></icon>
                <icon name="riv-users" scale="1" class="ord-close"
                          v-if="(scope.row.fornitori[0].tipoAzione.indexOf('3') < 0) && scope.row.fornitori[0].numDipendenti > 0"
                        ></icon>
              </div>-->
            </div>
          </div>
        </template>
      </el-table-column>

      <el-table-column header-align="center" align="center" width="40" v-if="ifAbilitatoDocRichiesti">

        <template slot="header" slot-scope="scope">
          <el-popover :key="scope.length"
            placement="top"
            trigger="click"
            popper-class="custom-popover"
          >
            <div slot="reference">
              <icon name="riv-help" class="pointer" scale="1"></icon>
            </div>
            <div class="legenda">
              <div>
                <icon :name="getStatoIcon('2')" class="status-rejected" scale="1"></icon>
                <span>{{ $t('ordini.raggStatus.2') }}</span>
              </div>
              <div>
                <icon :name="getStatoIcon('3')" class="status-rejected" scale="1"></icon>
                <span>{{ $t('ordini.raggStatus.3') }}</span>
              </div>
            </div>
          </el-popover>
        </template>
        <template slot-scope="scope">
          <div class="action">
            <icon class="ord-doc" :name="(scope.row.fornitori[0].staSitDoc === '0' ? 'riv-docAccepted_2' : 'riv-docRefused_2')" scale="1"
              v-if="(scope.row.fornitori[0].tipoAzione.indexOf('4') >= 0)"
              @click.native="goToDocumenti(scope.row, scope.row.fornitori[0])"
            />
          </div>
        </template>
      </el-table-column>

      <el-table-column header-align="center" align="center" width="40">

        <template slot-scope="scope">
          <div class="action">
              <icon name="riv-arrow" scale="1.1" class="ord-detail" v-if="(scope.row.fornitori[0].tipoAzione.indexOf('1') >= 0)"
                      @click.native="selectOrdine(scope.row, scope.row.fornitori[0].tipoAzione.indexOf('2') >= 0)"></icon>
            </div>
        </template>
      </el-table-column>

      <!--<el-table-column
        width="150">

        <template slot="header" slot-scope="scope">
          <el-popover :key="scope.length"
            placement="top"
            trigger="click"
            popper-class="custom-popover"
          >
            <div slot="reference">
              <div class="row row-custom no-padding">
                <div class="col-8 pointer">
                  <div>&nbsp;</div>
                </div>
                <div class="col-8 pointer right">
                  <icon name="riv-help" class="pointer" scale="1"></icon>
                </div>
                <div class="col-8 pointer">
                  <div>&nbsp;</div>
                </div>
              </div>
            </div>
            <div class="legenda">
              <div>
                <icon :name="getStatoIcon('2')" class="status-rejected" scale="1"></icon>
                <span>{{ $t('ordini.raggStatus.2') }}</span>
              </div>
              <div>
                <icon :name="getStatoIcon('3')" class="status-rejected" scale="1"></icon>
                <span>{{ $t('ordini.raggStatus.3') }}</span>
              </div>
            </div>
          </el-popover>
        </template>

        <template slot-scope="scope">
          <div class="actions">
            <div class="row row-custom">
              <div class="col-8 pointer">
                <icon name="riv-fornitori" scale="1" v-if="false"></icon>
                <div v-else>&nbsp;</div>
              </div>
              <div class="col-8 pointer">
                <icon :name="(scope.row.fornitori[0].staSitDoc === '0' ? 'riv-docAccepted_2' : 'riv-docRefused_2')" scale="1"
                      v-if="(scope.row.fornitori[0].tipoAzione.indexOf('4') >= 0)"
                      @click.native="goToDocumenti(scope.row, scope.row.fornitori[0])"></icon>
                <div v-else>&nbsp;</div>
              </div>
              <div class="col-8 pointer">
                <icon name="riv-arrow" scale="1.1" v-if="(scope.row.fornitori[0].tipoAzione.indexOf('1') >= 0)"
                      @click.native="selectOrdine(scope.row, scope.row.fornitori[0].tipoAzione.indexOf('2') >= 0)"></icon>
                <div v-else>&nbsp;</div>
              </div>
            </div>
          </div>
        </template>

      </el-table-column>-->
    </el-table>

    <el-pagination v-if="(nrPages > 1)" :current-page="currentPage"
                   background class="custom-pagination"
                   layout="prev, pager, next"
                   :total="nrItems"
                   :page-size="pag_for"
                   @current-change="changePage">
    </el-pagination>

    <el-dialog class="modalRiva" :title="$t('ordini.assDipTitle', {numOrd: pag_dip.ordine.numOrd, descFor: pag_dip.fornitore.descFor}).toUpperCase()"
               :visible.sync="modalAssociaDip"
               :before-close="closeAssociaDip"
               custom-class="custom-dialog col-lg-offset-2 col-lg-20 col-md-offset-2 col-md-20 col-sm-offset-2 col-sm-20 col-xs-24">

      <el-table :data="dipendenti" @sort-change="sortChangeDip" class="custom-table table-dialog" v-loading="loadingDip">

      <el-table-column
        width="45">

        <template slot-scope="scope">
          <el-tooltip class="item" effect="dark" :content="$t('ordini.dipIncompleto')" placement="top-start" :disabled="scope.row.completo === 'Y'">
            <el-checkbox :disabled="scope.row.completo === 'N'" v-if="pag_dip.operazione === 'E'" v-model="scope.row.associato" :key="scope.row.associato" @change="checkDip(scope.row)"></el-checkbox>
          </el-tooltip>
        </template>

      </el-table-column>

      <el-table-column
        header-align="center"
        width="250"
        prop="dipendente">

        <template slot-scope="scope" slot="header">
           <el-input :key="scope.toString()"
            v-model="filtri.dipendente"
            clearable
            :placeholder="$t('ordini.filtroDip')"
            class="custom-input"
            v-on:input="changeDip()"
          ></el-input>
        </template>
        <template slot-scope="scope">
           <div class="cell no-padding">
            <span class="bold">{{ scope.row.cognome }}  {{ scope.row.nome }}</span>
          </div>
        </template>

      </el-table-column>

      <el-table-column
        prop="desMansione"
        min-width="150"
        v-if="pag_dip.operazione === 'E'"
        :key="pag_dip.operazione">

        <template slot-scope="scope" slot="header">
          <el-select
            :key="scope.toString()"
            v-model="filtri.codMansione"
            :placeholder="$t('ordini.filtroMansione')"
            clearable
            class="custom-select-el"
            popper-class="rightSelect"
            v-on:change="changeMansione()"
          >
            <el-option
              v-for="item in tbl_mansione"
              :key="item.codMansione"
              :label="item.desMansione"
              :value="item.codMansione"
            ></el-option>
          </el-select>
        </template>

      </el-table-column>
      <el-table-column
       :label="$t('ordini.mansione')"
        prop="mansione"
        min-width="150"
        v-if="pag_dip.operazione === 'S'"
        :key="pag_dip.operazione">
      </el-table-column>

      <el-table-column header-align="center" align="center"
        :label="$t('ordini.dataNascita')"
        width="120">

        <template slot-scope="scope">
           <div class="cell no-padding">
            {{ scope.row.dataNascita === '' ? '' : moment(scope.row.dataNascita, 'YYYYMMDD').format('DD/MM/YYYY') }}
          </div>
        </template>

      </el-table-column>
      <el-table-column header-align="center" align="center"
        :label="$t('ordini.dataAssunzione')"
        width="120"
        prop="dataAssunzione"
        sortable="custom">

        <template slot-scope="scope">
           <div class="cell no-padding">
            {{ scope.row.dataAssunzione === '' ? '' : moment(scope.row.dataAssunzione, 'YYYYMMDD').format('DD/MM/YYYY') }}
          </div>
        </template>

      </el-table-column>
      <el-table-column
        :label="$t('ordini.tipoRapp')"
        min-width="200"
        sortable="custom"
        prop="tipoRapp">

        <template slot-scope="scope">
          <div class="cell no-padding">
            {{ scope.row.codTipoRap }}  {{ scope.row.desTipoRap }}
          </div>
        </template>

      </el-table-column>

      <el-table-column  header-align="center" align="center"
        :label="$t('ordini.CC') "
        width="120">

        <template slot-scope="scope">
          <el-checkbox :disabled="scope.row.completo === 'N' || !scope.row.associato || scope.row.SO || (pag_dip.capoCant !== '' && scope.row.codDip !== pag_dip.capoCant)" v-model="scope.row.CC" :key="scope.row.associato" @change="checkCapoCant(scope.row)"></el-checkbox>
        </template>

      </el-table-column>

      <el-table-column  header-align="center" align="center"
        :label="$t('ordini.SO')"
        width="120">

        <template slot-scope="scope">
          <el-checkbox :disabled="scope.row.completo === 'N' || !scope.row.associato || scope.row.codDip === pag_dip.capoCant" v-model="scope.row.SO" :key="scope.row.associato" @change="checkSostituto(scope.row)"></el-checkbox>
        </template>

      </el-table-column>


    </el-table>

    <el-pagination v-if="(pag_dip.nrPages > 1)" :current-page="pag_dip.currentPage" class="custom-pagination"
                   background
                   layout="prev, pager, next"
                   :total="pag_dip.nrItems"
                   :page-size="pag_dip.pag_for"
                   @current-change="changePageDip">
    </el-pagination>

      <span slot="footer" class="dialog-footer">
        <el-button v-if="pag_dip.operazione === 'S'" :loading="loaderBtn" class="custom-button"  @click="closeAssociaDip">{{ $t('ordini.chiudi') }}</el-button>
        <el-button v-if="pag_dip.operazione === 'E'" :loading="loaderBtn" class="custom-button"  @click="closeAssociaDip">{{ $t('ordini.annulla') }}</el-button>
        <el-button v-if="pag_dip.operazione === 'E'" :loading="loaderBtn" @click="saveAssociaDip" class="custom-button" type="primary">
          {{ $t('ordini.salva').toUpperCase() }}
        </el-button>
        </span>
    </el-dialog>

    <el-dialog class="modalRiva modal-document" :title="$t('ordini.upload').toUpperCase()"
               :visible.sync="ifUploadVisible" :close-on-click-modal="false" @close="ricerca(false)"
               custom-class="custom-dialog offset-xl-5 col-xl-14 col-lg-offset-3 col-lg-18 col-md-offset-1 col-md-22 col-24">

      <div class="upload">
        <div class="upload-file">
          <el-upload
            class="upload-demo" accept=".png, .jpg, .jpeg, .pdf, .doc, .docx, .xls, .xlsx"
            :on-change="changeUploadList" :on-exceed="handleExceed"
            :multiple="false" action="" :limit="1" :on-remove="handleRemove"
            :before-remove="beforeRemove"
            :auto-upload="false" ref="uploadDoc">
            <el-button size="mini" :disabled="(uploadList.length > 0 || loadingDoc)" class="custom-button">
              {{ $t('ordini.scegli') }}
            </el-button>
          </el-upload>
          <div class="bottoni">
            <el-button size="small" @click="uploadDoc" type="primary" class="custom-button"
                          :disabled="(uploadList.length === 0)"
                          :loading="loadingDoc">
              {{ $t('ordini.uploadButton').toUpperCase() }}
            </el-button>
          </div>
        </div>
      </div>

      <div class="tabella-documenti" v-loading="loadingDoc">
        <el-table :data="documentiOrdine" class="custom-table tabella-doc">
          <el-table-column
            :label="($t('ordini.idDocumento'))"
            prop="keyDoc"
            width="245">
          </el-table-column>
          <el-table-column
            prop="nomeDoc"
            :label="$t('ordini.nomeFile')"
            min-width="120">
          </el-table-column>
          <el-table-column
            :label="($t('ordini.utenteCaricamento'))"
            prop="username"
            min-width="120">
          </el-table-column>
          <el-table-column
            header-align="center" align="center"
            :label="$t('ordini.dataCaricamento')"
            width="165">

            <template slot-scope="scope">
              {{ moment(scope.row.dataDoc, 'DDMMYYYY').format('DD/MM/YYYY') + ' ' +
                 moment(scope.row.oraDoc, 'HHmmss').format('HH:mm') }}
            </template>

          </el-table-column>
          <el-table-column
            width="55" align="right">

            <template slot-scope="scope">
              <div class="icone-wrapper actions">
                <div class="col-24 no-padding">
                  <icon name="riv-downloadPas" class="pointer" scale="1" @click.native="getDoc(scope.row)"></icon>
                </div>
              </div>
            </template>

          </el-table-column>

        </el-table>
      </div>

    </el-dialog>
  </div>
</template>

<script>
  import Ricerca from '@/components/Fornitura/SituazioneOrdini/Ricerca'
  import {bus} from '@/components/Bus.js'
  import moment from 'moment'

  export default {
    name: 'Ordini',
    components: {Ricerca},
    props: {
      prefixApp: {
        type: String
      }
    },
    i18n: {
      messages: {
        it_IT: {
          ordini: {
            stato: '',
            ordine: 'Ordine',
            dataOrdine: 'Data Ordine',
            stabilimento: 'Stabilimento',
            fornitore: 'Fornitore',
            dettaglioOrdine: 'Visualizza Ordine',
            cerca: 'Cerca',
            ordineChiuso: 'Ordine Chiuso',
            ordineConScaduto: 'Ordine con Scaduto',
            raggStatus: {
              0: 'Nessun Documento Presente',
              1: 'Presenza di almeno un documento da approvare',
              2: 'Tutti i documenti sono in regola',
              3: 'Presenza di almeno un documento non in regola'
            },
            assDipTitle: 'Associazione Dipendente - Ordine N. {numOrd} ({descFor})',
            dipendente: 'Dipendente',
            dataNascita: 'Nato il',
            luogoNascita: 'Nato a',
            dataAssunzione: 'Assunto il',
            dataCessazione: 'Cessazione il',
            mansione: 'Mansione',
            tipoRapp: 'Tipo Rapporto',
            annulla: 'Annulla',
            salva: 'Salva',
            filtroDip: 'Filtra per Dipendente',
            filtroMansione: 'Filtra per Mansioni',
            salvataggioOK: 'Abbinamento fatto',
            chiudi: 'Chiudi',
            associa: 'Associa',
            mostra: 'Mostra',
            upload: 'Upload ordine firmato',
            scegli: 'Scegli...',
            uploadButton: 'Upload',
            idDocumento: 'ID Documento',
            nomeFile: 'Nome File',
            utenteCaricamento: 'Caricato da',
            dataCaricamento: 'Data Caricamento',
            caricamentoOK: 'Documento salvato correttamente',
            caricamentoKO: 'Errore di caricamento',
            dipIncompleto: 'Dipendente Incompleto, si prega di compilare le informazioni mancanti.',
            CC: 'Capo cantiere',
            SO: 'Sostituto CC'
          }
        },
        fr_FR: {
          ordini: {
            stato: '',
            ordine: 'Commande',
            dataOrdine: 'Date de commande',
            stabilimento: 'Usine',
            fornitore: 'Fournisseur',
            dettaglioOrdine: 'Détail de la Commande',
            cerca: 'Recherche',
            ordineChiuso: 'Commande Fermée',
            ordineConScaduto: 'Commande avec Expiré',
            raggStatus: {
              0: 'Aucun document présent',
              1: "Présence d'au moins un document à approuver",
              2: 'Tous les documents sont en règle',
              3: "Présence d'au moins un document non conforme"
            },
            assDipTitle: 'Association des employés - Commande N. {numOrd} ({descFor})',
            dipendente: 'Employé',
            dataNascita: 'Né le',
            luogoNascita: 'Né à',
            dataAssunzione: 'Embauché le',
            dataCessazione: 'Cessation le',
            mansione: 'Tâche',
            tipoRapp: 'Type de rapport',
            annulla: 'Annuler',
            salva: 'Enregistrer',
            filtroDip: 'Filtrer par employé',
            filtroMansione: 'Filtrer par tâches',
            salvataggioOK: 'Appairage terminé',
            chiudi: 'Fermer',
            associa: 'Associa',
            mostra: 'Mostra',
            upload: 'Télécharger la commande signée',
            scegli: 'Choisir...',
            uploadButton: 'Upload',
            idDocumento: 'Identifiant Document',
            nomeFile: 'Nom de Fichier',
            utenteCaricamento: 'Telechargé par',
            dataCaricamento: 'Date de Chargement',
            caricamentoOK: 'Document enregistré avec succès',
            caricamentoKO: 'Erreur de téléchargement',
            dipIncompleto: 'Employé incomplet, veuillez remplir les informations manquantes.',
            CC: 'chef chantier',
            SO: 'substitut CC'
          }
        },
        es_ES: {
          ordini: {
            stato: '',
            ordine: 'Pedido',
            dataOrdine: 'Fecha del Pedido',
            stabilimento: 'Fábrica',
            fornitore: 'Proveedor',
            dettaglioOrdine: 'Detalle del Pedido',
            cerca: 'Búsqueda',
            ordineChiuso: 'Pedido Cerrado',
            ordineConScaduto: 'Pedido Pendiente',
            raggStatus: {
              0: 'No hay documentos presentes',
              1: 'Presencia de al menos un documento para ser aprobado',
              2: 'Todos los documentos están en orden',
              3: 'Presencia de al menos un documento no en orden'
            },
            assDipTitle: 'Asociación de empleados - Orden N. {numOrd} ({descFor})',
            dipendente: 'Empleado',
            dataNascita: 'Nacido el',
            luogoNascita: 'Nacido en',
            dataAssunzione: 'Contratado el',
            dataCessazione: 'Cesado el',
            mansione: 'Tarea',
            tipoRapp: 'Tipo de relacion',
            annulla: 'Cancelar',
            salva: 'Guardar',
            filtroDip: 'Filtrar por empleado',
            filtroMansione: 'Filtrar por tareas',
            salvataggioOK: 'Emparejamiento hecho',
            chiudi: 'Cerrar',
            associa: 'Associa',
            mostra: 'Mostra',
            upload: 'Subir pedido firmado',
            scegli: 'Elegir...',
            uploadButton: 'Upload',
            idDocumento: 'ID Documento',
            nomeFile: 'Nombre Documento',
            utenteCaricamento: 'Subir Usuario',
            dataCaricamento: 'Fecha de Carga',
            caricamentoOK: 'Documento guardado exitosamente',
            caricamentoKO: 'Error de carga',
            dipIncompleto: 'Empleado incompleto, complete la información que falta.',
            CC: 'Gerente',
            SO: 'Adjunto'
          }
        },
        de_DE: {
          ordini: {
            stato: '',
            ordine: 'Bestellnr.',
            dataOrdine: 'Bestelldatum',
            stabilimento: 'Werk',
            fornitore: 'Lieferant',
            dettaglioOrdine: 'Bestelldetails',
            cerca: 'Suche',
            ordineChiuso: 'Geschlossene Bestellung',
            ordineConScaduto: 'Bestellung mit Lieferverzug',
            raggStatus: {
              0: 'Keine Dokumente vorhanden',
              1: 'Vorhandensein mindestens eines zu genehmigenden Dokuments',
              2: 'Alle Dokumente sind in Ordnung',
              3: 'Vorhandensein mindestens eines Dokuments nicht in Ordnung'
            },
            assDipTitle: 'Arbeitnehmerverband - Auftrag N. {numOrd} ({descFor})',
            dipendente: 'Mitarbeiter',
            dataNascita: 'Geboren am',
            luogoNascita: 'Geboren in',
            dataAssunzione: 'Angestellt am',
            dataCessazione: 'Aufgehört am',
            mansione: 'Aufgabe',
            tipoRapp: 'Arbeitsbeziehungstyp',
            annulla: 'Stornieren',
            salva: 'Speichern',
            filtroDip: 'Nach Mitarbeiter filtern',
            filtroMansione: 'Nach Pflichten filtern',
            salvataggioOK: 'Pairing erledigt',
            chiudi: 'schließen',
            associa: 'Associa',
            mostra: 'Mostra',
            upload: 'Upload-Bestellung unterschrieben',
            scegli: 'Wählen...',
            uploadButton: 'Upload',
            idDocumento: 'Dokument-ID',
            nomeFile: 'Dateiname',
            utenteCaricamento: 'Hochgeladen von',
            dataCaricamento: 'Ladedatum',
            caricamentoOK: 'Dokument erfolgreich gespeichert',
            caricamentoKO: 'Uploadfehler',
            dipIncompleto: 'Unvollständiger Mitarbeiter, bitte ergänzen Sie die fehlenden Informationen.',
            CC: 'Bauleiter',
            SO: 'Vize'
          }
        },
        en_GB: {
          ordini: {
            stato: '',
            ordine: 'Order',
            dataOrdine: 'Order date',
            stabilimento: 'Establishment',
            fornitore: 'Supplier',
            dettaglioOrdine: 'Order Details',
            cerca: 'Search',
            ordineChiuso: 'Closed Order',
            ordineConScaduto: 'Order with expired produtcs',
            raggStatus: {
              0: 'No Documents Present',
              1: 'Presence of at least one document to be approved',
              2: 'All documents are in order',
              3: 'Presence of at least one document not in order'
            },
            assDipTitle: 'Employee Association - Order N. {numOrd} ({descFor})',
            dipendente: 'Employee',
            dataNascita: 'Born on',
            luogoNascita: 'Born in',
            dataAssunzione: 'Hired on',
            dataCessazione: 'Ceased on',
            mansione: 'Task',
            tipoRapp: 'Relationship type',
            annulla: 'Cancel',
            salva: 'Save',
            filtroDip: 'Filter by Employee',
            filtroMansione: 'Filter by Duties',
            salvataggioOK: 'Pairing done',
            chiudi: 'Close',
            associa: 'Associa',
            mostra: 'Mostra',
            upload: 'Upload order signed',
            scegli: 'Choose...',
            uploadButton: 'Upload',
            idDocumento: 'Document ID',
            nomeFile: 'File Name',
            utenteCaricamento: 'Uploaded by',
            dataCaricamento: 'Upload Date',
            caricamentoOK: 'Document saved successfully',
            caricamentoKO: 'Upload error',
            dipIncompleto: 'Incomplete employee, please fill in the missing information.',
            CC: 'Foreman',
            SO: 'Deputy'
          }
        }
      }
    },
    data () {
      return {
        moment: moment,
        codLang: sessionStorage.getItem('codLang'),
        showSearchPanel: false,
        countries: [],
        societa: [],
        magazzini: [],
        form: {
          country: '',
          codForn: '',
          codSoc: '',
          codMag: '',
          annoOrd: '',
          numOrd: ''
        },
        listOrdini: [],
        pag_for: 12,
        ordine: '2D',
        fornitoriEspansi: [],
        expandRowKeys: [],
        fornitori: [],
        nrPages: 0,
        nrItems: 0,
        currentPage: 1,
        typeOfUser: '',
        inputSocDisabled: true,
        inputMagDisabled: true,
        loading: true,
        firstLoad: true,
        modalAssociaDip: false,
        loadingDip: false,
        dipendenti: [],
        pag_dip: {
          nrPages: 0,
          nrItems: 0,
          currentPage: 1,
          pag_for: 10,
          tipoOrd: '1A',
          fornitore: {},
          ordine: {},
          operazione: '',
          capoCant: '',
          setCapoCant: false
        },
        dipAssociati: [],
        tbl_mansione: [],
        filtri: {
          codMansione : '',
          dipendente: ''
        },
        loaderBtn: false,
        ifAbilitatoAssociaDip: false,
        ifAbilitatoDocRichiesti: false,
        ordineUpload: {},
        ifUploadVisible: false,
        uploadList: [],
        loadingDoc: false,
        documentiOrdine: []
      }
    },
    mounted: function () {
      bus.$on('changeLanguage', () => {
        this.$set(this, 'codLang', sessionStorage.getItem('codLang'))
      })
      bus.$on('Header_SetCodFornAdmin', () => {
        this.$set(this, 'listOrdini', [])
        this.$set(this, 'nrPages', 0)
        this.$set(this, 'nrItems', 0)
        this.$set(this, 'currentPage', 1)
      })
      bus.$on('UFFACQ_ChangeCountryFromDsh', () => {
        this.$set(this, 'listOrdini', [])
        this.$set(this, 'nrPages', 0)
        this.$set(this, 'nrItems', 0)
        this.$set(this, 'currentPage', 1)
      })
    },
    activated: function () {
      this.initialize()
    },
    methods: {
      getDoc: function (documento) {
        this.$http.get('portale/tokendoc')
          .then(response => {
            if (response.body.wsToken) {
              let url = (process.env.baseUrlSpringAcquisti + 'print/documento' +
                '?keyDoc=' + documento.keyDoc +
                '&idCli=' + documento.idCli + '&idApp=' + documento.idApp +
                '&token=' + response.body.wsToken
              )
              let win = window.open(url, '_blank')
              win.focus()
            } else {
              this.$message({
                showClose: true,
                message: 'Error creating token',
                type: 'error',
                duration: process.env.duration
              })
            }
          })
      },
      uploadDoc: function () {
        this.$set(this, 'loadingDoc', true)

        let formData = new FormData()
        formData.append('codLang', this.codLang)
        formData.append('country', this.form.country)
        formData.append('codForn', this.form.codForn)
        formData.append('codSoc', this.ordineUpload.codSoc)
        formData.append('codMag', this.ordineUpload.codMag)
        formData.append('annoOrd', this.ordineUpload.annoOrd)
        formData.append('numOrd', this.ordineUpload.numOrd)
        formData.append('variante', this.ordineUpload.variante)
        formData.append('file', this.uploadList[0].raw)

        this.$http.post('situazioneordini/' + this.prefixApp.toLowerCase() + '/docordine', formData)
          .then(response => {
            if (response.body.rc === 0) {
              this.$message({
                showClose: true,
                message: this.$t('ordini.caricamentoOK'),
                type: 'success',
                duration: process.env.duration
              })
              this.getDocOrdine()
            } else {
              this.$message({
                showClose: true,
                message: this.$t('ordini.caricamentoKO'),
                type: 'error',
                duration: process.env.duration
              })
              this.$set(this, 'loadingDoc', false)
            }
            this.$set(this, 'uploadList', [])
            this.$refs.uploadDoc.clearFiles()
          })
      },
      getDocOrdine: function () {
        this.$http.get('situazioneordini/' + this.prefixApp.toLowerCase() + '/docordine', {
          params: {
            codLang: this.codLang,
            country: this.form.country,
            codForn: this.form.codForn,
            codSoc: this.ordineUpload.codSoc,
            codMag: this.ordineUpload.codMag,
            annoOrd: this.ordineUpload.annoOrd,
            numOrd: this.ordineUpload.numOrd,
            variante: this.ordineUpload.variante
          }
        })
          .then(response => {
            if (response.body.rc === 0) {
              this.$set(this, 'documentiOrdine', response.body.data)
            } else {
              this.$message({
                showClose: true,
                message: response.body.msg[0].msgTxt,
                type: 'error',
                duration: process.env.duration
              })
            }
            this.$set(this, 'loadingDoc', false)
          })
      },
      beforeRemove: function () {
        // Se è attivo il loading del caricamento di un documento NON permetto di rimuovere il file
        if (this.loadingDoc) {
          return false
        }
      },
      handleRemove: function (file, fileList) {
        this.$set(this, 'uploadList', fileList)
      },
      handleExceed: function () {
        this.$message({
          showClose: true,
          message: 'Permesso solo l\'upload di un file alla volta',
          type: 'error',
          duration: process.env.duration
        })
      },
      changeUploadList: function (file, fileList) {
        this.$set(this, 'uploadList', fileList)
      },
      goToUpload: function (ordine) {
        this.$set(this, 'loadingDoc', true)
        this.$set(this, 'uploadList', [])
        this.$set(this, 'ordineUpload', ordine)
        this.$set(this, 'ifUploadVisible', true)
        this.getDocOrdine()
      },
      getStatoIcon: function (stato) {
        switch (stato) {
          case '0':
            return 'riv-docNew_2'
          case '1':
            return 'riv-docWaiting_2'
          case '2':
            return 'riv-docAccepted_2'
          case '3':
            return 'riv-docRefused_2'
          case '4':
            return 'riv-docRefused_3'
          default:
            return ''
        }
      },
      goToDocumenti: function (ordine, fornitore) {
        let obj = {
          codForn: this.form.codForn,
          country: this.form.country,
          fornitore: fornitore.codFor,
          desFornitore: fornitore.descFor,
          codSoc: ordine.codSoc,
          desSoc: ordine.desSoc,
          codMag: ordine.codMag,
          desMag: ordine.desMag,
          numOrd: ordine.numOrd,
          dipendente: '',
          generici: 'Y',
          attivi: 'N',
          statoCat: 'RIC',
          annoOrd: moment(ordine.datOrd, 'DDMMYYYY').format('YYYY'),
          tabActive: '0'
        }

        this.$store.commit('set', {key: 'DIP_Ricerca', value: {}})
        this.$store.commit('set', {key: 'DIP_Dipendente', value: {}})
        this.$store.commit('set', {key: 'DIP_new', value: false})
        this.$store.commit('set', {key: 'DIP_Documento', value: {}})
        this.$store.commit('set', {key: 'DOC_Ricerca', value: {}})
        this.$store.commit('set', {key: 'GA_Documento', value: {}})
        this.$store.commit('set', {key: 'ASD_Ricerca', value: {}})
        sessionStorage.removeItem('ACCSTA_fornitore')
        localStorage.setItem('ACCSTA_country', this.form.country)

        this.$store.commit('set', {key: 'DOC_Ricerca', value: obj})
        bus.$emit('changeActiveApp', 'WebDocRichiesti', 'ACCSTA')
        this.$router.push({ name: 'DOCElenco' , params: { areaAcq: true }})
      },
      setStatusDoc: function (row) {
        this.$http.get('portale/tokendoc')
          .then(response => {
            if (response.body.wsToken) {
              let url = (process.env.baseUrlSpringAcquisti + 'print/documento' +
                '?keyDoc=' + row.keyDoc +
                '&idCli=' + row.idCli + '&idApp=' + row.idApp +
                '&token=' + response.body.wsToken
              )
              let win = window.open(url, '_blank')
              win.focus()

              // Servizio di presa visione
              if (row.statusDoc === 'N') {
                this.$set(this, 'loading', true)

                let data = {
                  codLang: this.codLang,
                  country: this.form.country,
                  codForn: this.form.codForn,
                  codSoc: row.codSoc,
                  codMag: row.codMag,
                  annoOrd: row.datOrd.substr(4, 4),
                  numOrd: row.numOrd,
                  idCli: row.idCli,
                  idApp: row.idApp,
                  keyDoc: row.keyDoc,
                  variante: (row.hasOwnProperty('variante')) ? row.variante : '000'
                }

                this.$http.post('situazioneordini/' + this.prefixApp.toLowerCase() + '/setstatusdoc', data)
                  .then(response => {
                    if (response.body.rc === 0) {
                      this.ricerca(false)
                    } else {
                      this.$message({
                        showClose: true,
                        message: response.body.msg[0].msgTxt,
                        type: 'error',
                        duration: process.env.duration
                      })
                      this.loading = false
                    }
                  })
              }
            } else {
              this.$message({
                showClose: true,
                message: 'Error creating token',
                type: 'error',
                duration: process.env.duration
              })
            }
          })
      },
      initialize: function () {
        this.$nextTick(() => {
          if (sessionStorage.hasOwnProperty(this.prefixApp + '_form')) {
            this.$set(this, 'form', JSON.parse(sessionStorage.getItem(this.prefixApp + '_form')))
            this.ricerca(false)
            this.getMansioni()
            this.getIfAbilitato('ACCSTA', 'WebAssociaDip', 'AssociaDip', this.form.codForn)
            this.getIfAbilitato('ACCSTA', 'WebDocRichiesti', 'DocRichiesti', this.form.codForn)
          }
        })
      },
      setLoading: function (val) {
        this.$set(this, 'loading', val)
      },
      /*  Sul click dell'utente per accedere al dettaglio dell'ordine viene salvato un oggetto contenete i dati dell'ordine selezionato
          nel sessionStorage e viene fatto un redirect alla pagina di dettaglio
       */
      selectOrdine: function (ordine, ifNuovo) {
        let obj = {
          numOrd: ordine.numOrd,
          codSoc: ordine.codSoc,
          codMag: ordine.codMag,
          datOrd: ordine.datOrd,
          annoOrd: ordine.datOrd.substr(4, 4),
          codForn: this.form.codForn,
          country: this.form.country,
          ifNuovo: ifNuovo
        }
        sessionStorage.setItem(this.prefixApp + '_ordine', JSON.stringify(obj))
        this.$router.push({name: this.prefixApp + 'DettaglioOrdine'})
      },
      changePage: function (page) {
        this.currentPage = page
        this.ricerca(false)
      },
      /*  Viene richiamata quando l'utente clicca sulle frecce di ordinamento della tabella. Setta il codice di ordinamento corrispondente
       *  e richiama il servizio di ricerca con questo codice
       */
      sortChange: function ({column, prop, order}) {
        if (prop === 'numOrd') {
          if (order === 'ascending') {
            this.ordine = '1A'
          } else if (order === 'descending') {
            this.ordine = '1D'
          }
        } else if (prop === 'datOrd') {
          if (order === 'ascending') {
            this.ordine = '2A'
          } else if (order === 'descending') {
            this.ordine = '2D'
          }
        }
        this.ricerca(true)
      },
      /*  Ritorna il nome della classe da aggiungere nell'accordion alle colonne di destra per lo sfondo evidenziato  */
      cellClassAccordion: function ({row, column, rowIndex, columnIndex}) {
        if (columnIndex > 4) {
          return 'cella-evidenziata'
        }
        return ''
      },
      tableRowClassName: function ({row, rowIndex}) {
        let classes = ''
        if (row.fornitori.length > 1) {
          classes = 'multiple riga-hover'
        } else {
          classes = 'single riga-hover'
        }
        /*if (rowIndex % 2 === 0) {
          classes += ' odd'
        } else {
           classes += ' even'
        }*/
        return classes
      },
      /*  Ritorna l'array dei fornitori di una riga della tabella da mostrare nell'accordion  */
      getArray: function (index) {
        // console.log(index)
        return this.fornitori[index]
      },
      openSearch: function () {
        this.showSearchPanel = true
        this.$emit('hideScroll')
        this.$emit('closeMessages')
      },
      closeSearch: function () {
        this.$emit('showScroll')
        this.showSearchPanel = false
      },
      cerca: function (form) {
        let formRicerca = JSON.parse(form)
        this.$set(this, 'form', formRicerca)
        this.$set(this, 'currentPage', 1)
        if (!this._inactive) {
          this.getMansioni()
          this.getIfAbilitato('ACCSTA', 'WebAssociaDip', 'AssociaDip', this.form.codForn)
          this.getIfAbilitato('ACCSTA', 'WebDocRichiesti', 'DocRichiesti', this.form.codForn)
          this.ricerca(false)
        }
      },
      /*  flagIfChangeSort = TRUE solo se si sta richiamando la ricerca in seguito al cambio dell'ordinamento delle colonne  */
      ricerca: function (flagIfChangeSort) {
        // Questa funzione viene chiamata anche chiudendo la modal dei documenti per cui svuoto i file per l'upload
        if (this.$refs.uploadDoc) {
          this.$refs.uploadDoc.clearFiles()
        }
        this.$set(this, 'loading', true)
        if (flagIfChangeSort) {
          this.$set(this, 'form', JSON.parse(sessionStorage.getItem(this.prefixApp + '_form')))
          this.$set(this, 'currentPage', 1)
        }

        // Flag per sapere se ho cambiato Stato e/o codForn
        let flagChange = false

        // Se il codForn salvato nel sessionStorage è diverso da quello in utilizzo nel component allora lo cambio
        if (sessionStorage.getItem('UFFACQ_fornitore') !== this.form.codForn) {
          sessionStorage.setItem('UFFACQ_fornitore', this.form.codForn)
          flagChange = true
        }

        // Se lo Stato salvato nel localStorage è diverso da quello in utilizzo nel component allora lo cambio
        if (localStorage.getItem('UFFACQ_country') !== this.form.country) {
          localStorage.setItem('UFFACQ_country', parseInt(this.form.country))
          flagChange = true
        }
        bus.$emit('Header_ChangeAdmin', this.form.country, 'UFFACQ')

        // Sono cambiati Stato e/o codForn
        if (flagChange) {
          bus.$emit('UFFACQ_ChangeCountryFromApp')
        }
        this.$http.get('situazioneordini/' + this.prefixApp.toLowerCase() + '/ordini', {
          params: {
            codLang: this.codLang,
            country: this.form.country,
            codForn: this.form.codForn,
            codSoc: this.form.codSoc,
            codMag: this.form.codMag,
            annoOrd: this.form.annoOrd,
            numOrd: this.form.numOrd,
            tipOrd: this.ordine,
            pag_action: (this.currentPage > 1) ? 'NEXT' : 'BEGIN',
            pag_from: this.currentPage,
            pag_for: this.pag_for,
            tipoOrd: (this.prefixApp === 'BdR') ? 'M' : '',
            onlyActive : 'N'
          }
        })
          .then(response => {
            if (response.body.rc === 0) {
              sessionStorage.setItem(this.prefixApp + '_form', JSON.stringify(this.form))
              this.$set(this, 'listOrdini', response.body.data)
              if (this.currentPage === 1) {
                this.$set(this, 'nrPages', parseInt(response.body.attrib.pages))
                this.$set(this, 'nrItems', parseInt(response.body.attrib.size))
              }
              for(let i = 0; i < this.listOrdini.length; i++) {
                let arr = JSON.parse(JSON.stringify(response.body.data))[i].fornitori
                this.$set(this.fornitori, i, (arr.length > 1 ? arr.splice(1, arr.length) : []))
              }
            } else {
              this.$message({
                showClose: true,
                message: response.body.msg[0].msgTxt,
                type: 'error',
                duration: process.env.duration
              })
              this.$set(this, 'listOrdini', [])
              this.$set(this, 'nrPages', 0)
              this.$set(this, 'nrItems', 0)
            }
            this.closeSearch()
            this.$set(this, 'loading', false)
          })
      },
      associaDip: function (ordine, fornitore, tipoOp) {
        this.$set(this, 'modalAssociaDip', true)
        this.$set(this.pag_dip, 'currentPage', 1)
        this.$set(this.pag_dip, 'nrPages', 0)
        this.$set(this.pag_dip, 'nrItems', 0)
        this.$set(this.pag_dip, 'tipoOrd', '1A')
        this.$set(this.pag_dip, 'ordine', ordine)
        this.$set(this.pag_dip, 'fornitore', fornitore)
        this.$set(this.pag_dip, 'operazione', tipoOp)
        this.$set(this.pag_dip, 'capoCant', "")
        this.$set(this.pag_dip, 'setCapoCant', true)
        this.$set(this, 'dipendenti', [])
        this.$set(this, 'dipAssociati', this.pag_dip.fornitore.dipendenti)
        console.log(this.pag_dip.fornitore.dipendenti)
        tipoOp === 'E' ? this.listDipendenti() : this.listDipendentiAcq()
      },
      closeAssociaDip: function (ordine, fornitore) {
        this.$set(this.pag_dip, 'currentPage', 1)
        this.$set(this.pag_dip, 'nrPages', 0)
        this.$set(this.pag_dip, 'nrItems', 0)
        this.$set(this.pag_dip, 'tipoOrd', '1A')
        this.$set(this.pag_dip, 'ordine', {})
        this.$set(this.pag_dip, 'fornitore', {})
        this.$set(this.filtri, 'codMansione', '')
        this.$set(this.filtri, 'dipendente', '')
        this.$set(this.pag_dip, 'capoCant', "")
        this.$set(this.pag_dip, 'setCapoCant', false)
        this.$set(this, 'dipendenti', [])
        this.$set(this, 'dipAssociati', [])
        this.$set(this, 'modalAssociaDip', false)
      },
      changePageDip: function (page) {
        this.$set(this.pag_dip, 'currentPage', page)
        this.pag_dip.operazione === 'E' ? this.listDipendenti() : this.listDipendentiAcq()
      },
      sortChangeDip: function ({column, prop, order}) {
        if (prop === 'dipendente') {
          if (order === 'ascending') {
            this.$set(this.pag_dip, 'tipoOrd', '1A')
          } else if (order === 'descending') {
            this.$set(this.pag_dip, 'tipoOrd', '1D')
          }
        } else if (prop === 'dataAssunzione') {
          if (order === 'ascending') {
             this.$set(this.pag_dip, 'tipoOrd', '2A')
          } else if (order === 'descending') {
             this.$set(this.pag_dip, 'tipoOrd', '2D')
          }
        } else if (prop === 'desMansione') {
          if (order === 'ascending') {
             this.$set(this.pag_dip, 'tipoOrd', '3A')
          } else if (order === 'descending') {
             this.$set(this.pag_dip, 'tipoOrd', '3D')
          }
        } else if (prop === 'tipoRapp') {
          if (order === 'ascending') {
             this.$set(this.pag_dip, 'tipoOrd', '4A')
          } else if (order === 'descending') {
             this.$set(this.pag_dip, 'tipoOrd', '4D')
          }
        }
        this.$set(this.pag_dip, 'currentPage', 1)
        this.$set(this.pag_dip, 'nrPages', 0)
        this.$set(this.pag_dip, 'nrItems', 0)
        this.$set(this, 'dipendenti', [])
        this.pag_dip.operazione === 'E' ? this.listDipendenti() : this.listDipendentiAcq()
      },
      changeMansione: function() {
        this.$set(this.pag_dip, 'currentPage', 1)
        this.$set(this.pag_dip, 'nrPages', 0)
        this.$set(this.pag_dip, 'nrItems', 0)
        this.listDipendenti()
      },
      changeDip: function() {
        if (this.filtri.dipendente === '' || this.filtri.dipendente.length >= 3) {
          this.$set(this.pag_dip, 'currentPage', 1)
          this.$set(this.pag_dip, 'nrPages', 0)
          this.$set(this.pag_dip, 'nrItems', 0)
          this.pag_dip.operazione === 'E' ? this.listDipendenti() : this.listDipendentiAcq()
        }
      },
      // Elenco dei dipendenti di una società, servizio PAGHE
      listDipendenti: function () {
        this.$set(this, 'loadingDip', true)
        this.$http.get('situazioneordini/' + this.prefixApp.toLowerCase()  + '/dipendenti', {
          params: {
            codLang: this.codLang,
            country: this.form.country,
            codForn: this.form.codForn,
            fornitore: this.pag_dip.fornitore.codFor,
            codSoc: this.pag_dip.ordine.codSoc,
            codMag: this.pag_dip.ordine.codMag,
            annoOrd: this.pag_dip.ordine.annoOrd,
            numOrd: this.pag_dip.ordine.numOrd,
            dipendente: this.filtri.dipendente,
            mansione: this.filtri.codMansione === undefined ? '' : this.filtri.codMansione,
            pag_action: (this.pag_dip.currentPage > 1) ? 'NEXT' : 'BEGIN',
            pag_from: (this.pag_dip.currentPage - 1) * this.pag_dip.pag_for + 1,
            pag_for: this.pag_dip.pag_for,
            tipOrd: this.pag_dip.tipoOrd
          }
        })
          .then(response => {
            if (response.body.rc === 0) {
              //this.$set(this, 'dipendenti', response.body.data)
              let _this = this
              this.dipendenti = response.body.data.map(function(obj) {
                if (_this.dipAssociati.find(x => x.codDip === obj.codDip) === undefined) {
                  obj.associato = false
                } else {
                  obj.associato = true
                }
                obj.CC = obj.ruolo === 'C' ? true : false
                obj.SO = obj.ruolo === 'S' ? true : false
                /*if (obj.seAbbinato === '1') {
                  obj.associato = true
                } else {
                  obj.associato = false
                }*/
                  return obj;
              })

              if (this.pag_dip.setCapoCant) {
                this.$set(this.pag_dip, 'capoCant', response.body.attrib.capoCant)
                this.$set(this.pag_dip, 'setCapoCant', false)
              }

              if (this.pag_dip.currentPage === 1) {
                this.$set(this.pag_dip, 'nrItems', parseInt(response.body.attrib.size))

                let resto = parseInt(response.body.attrib.size) % this.pag_dip.pag_for
                let aggiunta = (resto > 0) ? 1 : 0
                let nrPages = Math.floor(parseInt(response.body.attrib.size) / this.pag_dip.pag_for) + aggiunta
                this.$set(this.pag_dip, 'nrPages', nrPages)

              }
            } else {
              this.$set(this, 'dipendenti', [])
              this.$set(this.pag_dip, 'currentPage', 1)
              this.$set(this.pag_dip, 'nrPages', 0)
              this.$set(this.pag_dip, 'nrItems', 0)
            }
            this.$set(this, 'loadingDip', false)
          })
      },
      // Elenco dei solo dipendenti associati ad un ordine, servizio UFF. ACQUISTI
      listDipendentiAcq: function (row) {
        this.$set(this, 'loadingDip', true)
        this.$http.get('situazioneordini/' + this.prefixApp.toLowerCase() + '/dipendentiacq', {
          params: {
            codLang: this.codLang,
            country: this.form.country,
            codForn: this.form.codForn,
            fornitore: this.pag_dip.fornitore.codFor,
            dipendente: this.filtri.dipendente,
            codSoc: this.pag_dip.ordine.codSoc,
            codMag: this.pag_dip.ordine.codMag,
            numOrd: this.pag_dip.ordine.numOrd,
            annoOrd: this.pag_dip.ordine.annoOrd,
            generici: 'Y',
            pag_action: (this.pag_dip.currentPage > 1) ? 'NEXT' : 'BEGIN',
            pag_from: (this.pag_dip.currentPage - 1) * this.pag_dip.pag_for + 1,
            pag_for: this.pag_dip.pag_for
          }
        })
          .then(response => {
            if (response.body.rc === 0) {

              //this.$set(this, 'dipendenti', response.body.data)
              this.dipendenti = response.body.data.map(function(obj) {
                obj.CC = obj.ruolo === 'C' ? true : false
                obj.SO = obj.ruolo === 'S' ? true : false
                return obj;
              })

              /*if (this.pag_dip.setCapoCant) {
                this.$set(this.pag_dip, 'capoCant', response.body.attrib.capoCant)
                this.$set(this.pag_dip, 'setCapoCant', false)
              }*/

              if (this.pag_dip.currentPage === 1) {
                this.$set(this.pag_dip, 'nrItems', parseInt(response.body.attrib.size))

                let resto = parseInt(response.body.attrib.size) % this.pag_dip.pag_for
                let aggiunta = (resto > 0) ? 1 : 0
                let nrPages = Math.floor(parseInt(response.body.attrib.size) / this.pag_dip.pag_for) + aggiunta
                this.$set(this.pag_dip, 'nrPages', nrPages)
              }
            } else {
              this.$set(this, 'dipendenti', [])
              this.$set(this.pag_dip, 'currentPage', 1)
              this.$set(this.pag_dip, 'nrPages', 0)
              this.$set(this.pag_dip, 'nrItems', 0)
            }
            this.$set(this, 'loadingDip', false)
          })
      },
      checkDip: function (row) {
        if (row.associato) {
          let obj= {
            codDip: row.codDip,
            descDip: row.cognome + " " + row.nome
          }
           this.dipAssociati.push(obj)
        } else {
          this.dipAssociati = this.dipAssociati.filter(function( obj ) {
            return obj.codDip !== row.codDip;
          });
          if (row.CC) {
            this.$set(this.pag_dip, 'capoCant','')
          }
          row.CC = false
          row.SO = false
        }
      },
      checkCapoCant: function (row) {
        this.dipAssociati = this.dipAssociati.filter(function( obj ) {
          if (obj.codDip !== row.codDip) {
            return obj
          } else {
            obj.ruolo = row.CC ? 'C' : ''
            return obj
          }
        })
        this.$set(this.pag_dip, 'capoCant', row.CC ? row.codDip : '')
      },
      checkSostituto: function (row) {
        this.dipAssociati = this.dipAssociati.filter(function( obj ) {
          if (obj.codDip !== row.codDip) {
            return obj
          } else {
            obj.ruolo = row.SO ? 'S' : ''
            return obj
          }
        })
      },
      elencoDip: function (row) {
        let elenco = ''
        for (var key in row.fornitori[0].dipendenti) {
            elenco += row.fornitori[0].dipendenti[key].descDip + '\n'
        }
        return elenco
      },
      getMansioni: function() {
        this.$http.get('situazioneordini/' + this.prefixApp.toLowerCase() + '/mansioni', {
          params: {
            codLang: this.codLang,
            country: this.form.country
          }
        })
        .then(response => {
          if (response.body.rc === 0) {
            this.$set(this, 'tbl_mansione', response.body.data)
          } else {
            this.$message({
              showClose: true,
              message: response.body.msg[0].msgTxt,
              type: 'error',
              duration: process.env.duration
            })
          }
        })
      },
      saveAssociaDip: function () {
        this.$set(this, 'loaderBtn', true)
        this.$http.post('situazioneordini/' + this.prefixApp.toLowerCase() + '/associadip',
          {
            codLang: this.codLang,
            country: this.form.country,
            codForn: this.form.codForn,
            fornitore: this.pag_dip.fornitore.codFor,
            numOrd: this.pag_dip.ordine.numOrd,
            annoOrd: this.pag_dip.ordine.annoOrd,
            codSoc: this.pag_dip.ordine.codSoc,
            codMag: this.pag_dip.ordine.codMag,
            numDipendenti: this.dipAssociati.length,
            dipendenti: this.dipAssociati
          }
        )
          .then(response => {
            if (response.body.rc === 0) {
             this.$message({
                showClose: true,
                message: response.body.msg[0].msgTxt,
                type: 'success',
                duration: process.env.duration
              })
              this.closeAssociaDip()
              this.ricerca(false)
            } else {
              this.$message({
                showClose: true,
                message: response.body.msg[0].msgTxt,
                type: 'error',
                duration: process.env.duration
              })
            }
            this.$set(this, 'loaderBtn', false)
          })
      },
      getDesMansione: function(row) {
        return this.pag_dip.operazione === 'E' ? row.desMansione  : row.mansione
      },
      getIfAbilitato: function(area, codiApp, param, codForn) {
        this.$http.get('portale/checkabilitazione', {
          params: {
            area: area,
            codiApp: codiApp,
            country: this.form.country,
            codForn: codForn,
            codLang: this.codLang
          }
        })
          .then(response => {
            if (response.body.rc === 0) {
              this.$set(this, 'ifAbilitato' + param, response.body.attrib.ifAbilitato)
            } else {
              this.$set(this, 'ifAbilitato' + param, false)
              this.$message({
                showClose: true,
                message: response.body.msg[0].msgTxt,
                type: 'error',
                duration: process.env.duration
              })
            }
          })
      },
      getTableKey: function(row) {
        return row.codSoc + row.codMag + row.numOrd
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
  @import "../../../assets/less/general.less";
  @import "../../../assets/less/el-dialog.less";

  .modal-document {
    .tabella-doc {
      height: unset !important;
      max-height: 200px;
      min-height: 100px;
      margin-top: 25px;
      overflow: auto;
      .el-table__body {
        .cell-no-padding-left {
          .cell {
            padding-left: 0 !important;
          }
        }
        .cell {
          .cerchio {
            height: 9px;
            width: 9px;
            border-radius: 5px;
          }
          .verde {
            background-color: #0B7E26;
          }
          .giallo {
            background-color: #FFD506;
          }
          .rosso {
            background-color: #E51717;
          }
        }
      }
    }
    .upload {
      margin-top: 10px;
      .tipo-doc-label {
        .set-font(@color: @greenRiva, @size: 15px, @family: 'os-regular');
        display: inline-block;
        margin-right: 15px;
      }
      .custom-select-el {
        display: inline-block;
        margin-bottom: 20px;
        width: 330px;
        .el-input__inner {
          border: 0;
          border-bottom: 1px solid #ccc;
        }
      }
      .upload-demo {
        display: inline-block;
        width: 520px;
        vertical-align: middle;
        .el-upload {
          // display: inline-block;
          width: 150px;
          text-align: right;
          padding-left: 15px;
          vertical-align: middle;
          float: right;
          .el-button {
            width: 150px;
          }
        }
        .el-upload-list__item:first-child {
          margin-top: 0;
        }
        .el-upload-list {
          width: 370px;
          display: inline-block;
          border: 1px solid #ccc;
          height: 28px;
          text-align: right;
          vertical-align: middle;
          .el-upload-list__item {
            text-align: left;
            height: 26px;
            line-height: 26px;
            .el-icon-close {
              top: 7px;
            }
          }
        }
      }
      .bottoni {
        display: inline-block;
        width: 100px;
        vertical-align: middle;
        text-align: right;
        margin-left: 25px;
        .el-button {
            width: 150px;
          }
      }
    }
  }

  @media only screen and (max-width: 1250px) and (min-width: 881px) {
    .modal-document {
      .el-dialog__body {
        .upload {
          .upload-demo {
            width: 450px;
            .el-upload-list {
              width: 300px;
            }
          }
        }
      }
    }
  }

  @media only screen and (max-width: 880px) {
    .modal-document {
      .el-dialog__body {
        .upload {
          .upload-demo {
            width: 350px;
            .el-upload-list {
              width: 200px;
            }
          }
        }
      }
    }
  }

  .ordini {
    height: 100%;
    .header-tab {
      height: 65px;
      text-align: center;
      .icon-search {
        line-height: 65px;
        .el-button {
          height: 40px;
          width: 40px;
          border-radius: 0px;
          margin-top: 12px;
          margin-left: 10px;
          padding: 0;
          color: @greenRiva;
          float: left;
          border: 1px solid @greenRiva;
        }
      }
    }
    .el-table {
      height: 460px;
      .el-table__header {
        thead {
          th {
            .cell {
              .el-popover__reference {
                line-height: 16px;
                padding: 0;
                overflow: inherit !important;
                div {
                  overflow: inherit !important;
                  line-height: 16px;
                }
                .right {
                  text-align: right;
                }
              }
            }
          }
        }
      }
      .el-table__body {
        tbody {
          tr {
            .cell {
              .actions {
                .row-custom {
                  div {
                    padding: 0 7px;
                    text-align: right;
                  }
                }
              }
            }
            &.expanded {
              background-color: #eff6f6;
              td {
                background-color: #eff6f6 !important;
              }
            }
            .el-table__expanded-cell {
              padding: 0 !important;
              .el-table__header-wrapper {
                display: none;
              }
              .el-table__fixed-body-wrapper {
                top: 0 !important;
              }
              .el-table {
                height: auto !important;
                .el-table__body {
                  tr {
                    td {
                      border-bottom: 0 !important;
                      &.cella-evidenziata {
                        background-color: #eff6f6;
                      }
                    }
                  }
                }
              }
              .el-table::before {
                height: 0;
              }
              .el-table__empty-block {
                display: none;
              }
            }
          }
        }
      }
    }
    .table-dialog {
      height: 400px;
      .el-table__header-wrapper {
        .el-select {
          padding-left: 0px;
          padding-right: 0px;
          .el-input {
            padding-left: 0px;
            padding-right: 0px;
            .el-input__inner {
              border-color: #c0c4cc !important;
              &:focus {
                border-color: #c0c4cc !important;
              }
              &:hover {
                border-color: #c0c4cc !important;
              }
            }
          }
        }
        .custom-input {
          .el-input__inner {
            border-bottom: 1px solid #c0c4cc !important;
            &:focus {
              border-color: #c0c4cc !important;
            }
            &:hover {
              border-color: #c0c4cc !important;
            }
          }
        }
      }
    }
    .ord-open {
      color: @rossoRiva;
      cursor: pointer;
    }
    .ord-close {
      color: #ccc;
    }
    .ord-detail{
      color: @rossoRiva;
      cursor: pointer;
    }
    .ord-doc{
      cursor: pointer;
    }
    .action {
      .el-popover__reference {
        cursor: pointer;
        .el-badge {
          .el-badge__content {
            height: 18px;
            width: 18px;
            // top: 1px;
            //right: -3px;
            padding: 0;
            line-height: 16px;
            .set-font(@color: @white, @size: 10px);
            letter-spacing: 0;
            background-color: @oroRiva;
          }
        }
      }

    }

    .el-badge {
      .el-badge__content {
        right: 60px; //115px;
        top: 8px;
        .set-font(@color: @white, @size: 10px);
        letter-spacing: 0;
        background-color: @oroRiva;
        line-height: 14px;
      }
    }
    .associa-button {
      margin-left: 10px;
      width: 50px; //100px
      .set-font(@family: 'os-regular', @size: 12px, @color: @white);
      letter-spacing: 2px;
      border: 1px solid @rossoRiva;
      background-color: @rossoRiva;
      border-radius: 10px;
      height: 22px; // 26px;
      padding: 2px; // 5px;
      .fa-icon {
        color: #fff;
      }
    }
    .mostra-button {
      margin-left: 10px;
      width: 50px; //100px
      .set-font(@family: 'os-regular', @size: 12px, @color: @rossoRiva);
      letter-spacing: 2px;
      border: 1px solid @rossoRiva;
      background-color: @white;
      border-radius: 10px;
      height: 22px; // 26px;
      padding: 2px; // 5px;
      .fa-icon {
        color: @rossoRiva;
      }
    }
  }
  .riv-denied-c0 {
    fill: #818181;
  }
  .riv-details-c0 {
    fill: #818181;
  }
  .riv-fornitori-c0 {
    fill: @oroRiva;
  }
  .riv-docFornitore-c0 {
    fill: @oroRiva;
  }
  .ordini-elencoDip {
      line-height: 20px !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/Fornitura/SituazioneOrdini/Ordini.vue